module.exports = __webpack_public_path__ + "img/promo_Marketing.a59eacdc.svg";